import { helper } from '@ember/component/helper';

export function clientRect([el]: [Element]): DOMRect {
  return el?.getBoundingClientRect();
}

export default helper(clientRect);
